import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { Campaign } from "../../models/campaign.model";
import { Oauth2Service } from "../../services/oauth2.service";

let Consent = {
    selector: "vcConsent",
    templateUrl: "/angular/components/profile/consent.component.html",
    bindings: {},
    controller: class ConsentController {
        public campaignid: number;
        public campaign: Campaign;
        public url: any;
        public app: any = null;
        public error: string | undefined = undefined;
        public authorize: any;
        public accessToken: any;
        public resource: any;
        public activeCampaign: Campaign;

        public __env: any;
        private $http: any;
        private $window: any;
        private $location: any;

        private oAuth2Service: Oauth2Service;

        constructor(
            __env: any,
            $http: any,
            $routeParams: any,
            $window: any,
            $location: any,
            CampaignDataProvider: CampaignDataProvider,
            Oauth2Service: Oauth2Service
        ) {
            this.__env = __env;
            this.$http = $http;
            this.$window = $window;
            this.$location = $location;

            this.oAuth2Service = Oauth2Service;

            this.campaignid = $routeParams.campaignid;
            this.url = this.$location.search();

            this.oAuth2Service.app(this.url).then((response: object) => {
                const json = response["data"];
                if (json.success) {
                    this.app = json.data;
                } else {
                    this.error = "App not found";
                }
            });

            CampaignDataProvider.info(this.url.campaignid).then(
                (campaign: Campaign) => (this.campaign = campaign.attributes)
            );
        }

        confirm(): void {
            this.app.campaignid = this.campaign.campaignid;
            this.oAuth2Service
                .createCampaignApp(this.app)
                .then((response: object) => {
                    const json = response["data"];
                    if (json.success) {
                        this.getOauthAuthorize(this.app);
                    }
                });
        }

        getOauthAuthorize(clientInfo: any): void {
            this.authorize = {
                client_id: clientInfo.client_id,
                redirect_uri: clientInfo.redirect_uri,
                grant_type: "authorization_code",
                scope: "full",
            };

            const url =
                "/api/oauth2/authorize/" +
                this.campaignid +
                "/code/" +
                clientInfo.client_id +
                "/this_is_the_autorization_code/?redirect_uri=" +
                clientInfo.redirect_uri;
            this.$http.get(url, this.authorize).then((response: any) => {
                if (response.data.status) {
                    clientInfo.code = response.data.code;
                    clientInfo.client_secret = response.data.client_secret;
                    this.getOauthGrant(clientInfo);
                }
            });
        }
        getOauthGrant(clientInfo: any): void {
            this.accessToken = {
                grant_type: "authorization_code",
                code: clientInfo.code,
                redirect_uri: clientInfo.redirect_uri,
                client_id: clientInfo.client_id,
                selectedCampaignid: this.campaignid,
                client_secret: clientInfo.client_secret,
            };

            this.oAuth2Service
                .grant(this.accessToken)
                .then((response: object) => {
                    const json = response["data"];
                    if (json.access_token) {
                        this.getResourceAccess(response);
                    }
                });
        }

        getResourceAccess(token: any): void {
            this.resource = {
                access_token: token.access_token,
                selectedCampaignid: this.activeCampaign.campaignid,
            };

            this.oAuth2Service.resource(this.resource);
        }

        cancel(): void {
            this.$window.location = "/#/";
        }
    },
};

angular.module("profile").component(Consent.selector, Consent);
